import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#radio" }),
    /*#__PURE__*/_createTextVNode(" Radio ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Single selection among multiple options. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIDisabled = _resolveComponent("EUIDisabled")
  const _component_EUIRadioButtonGroup = _resolveComponent("EUIRadioButtonGroup")
  const _component_EUIButtonStyle = _resolveComponent("EUIButtonStyle")
  const _component_EUIWithBorders = _resolveComponent("EUIWithBorders")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIDisabled),
    _createVNode(_component_EUIRadioButtonGroup),
    _createVNode(_component_EUIButtonStyle),
    _createVNode(_component_EUIWithBorders)
  ], 64))
}